import { AirportLocation } from '@reward-platform/flights-schemas'
import formatAirportName from '~/utils/formatAirportName'

/**
 * Workaround for missing functionality in the ComboBox component.
 * react-hook-form can focus on the input element if a ref is passed to input.
 *
 * @param searchBoxName
 */
export function focusSearchBox(searchBoxName: string, options?: FocusOptions) {
  const input = document.getElementById(searchBoxName)

  if (!input) {
    return false
  }

  if (input instanceof HTMLInputElement) {
    input.focus(options)
    return true
  }
  const target = input.querySelector('input')

  if (target instanceof HTMLInputElement) {
    target.focus(options)
    return true
  }

  return false
}

export function buildSearchCriteria(item: AirportLocation): string {
  const airportLabel = formatAirportName(item)
  const typeAheadTextCriteria = [
    airportLabel,
    item.cityName,
    `${item.countryName} (${item.countryCode})`,
  ]

  if (item.stateName?.length) {
    typeAheadTextCriteria.push(item.stateName)
  }
  return typeAheadTextCriteria.join(', ')
}
